import { createContext, useContext } from 'react';
import type { NavItem } from '@/config/navigation';

interface LayoutContextValue {
  hasSidebar: boolean;
  subNavItems: NavItem[];
  pathname: string;
}

export const LayoutContext = createContext<LayoutContextValue>({
  hasSidebar: false,
  subNavItems: [],
  pathname: '',
});

export function useLayout() {
  return useContext(LayoutContext);
}
